import React from 'react';
import IntegrationsGuide from '@/components/admin/IntegrationsGuide';

export default function IntegrationsGuidePage() {
  return <IntegrationsGuide />;
}